class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    // Set header bottom position if not already set
    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') === '') {
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
    }

    // Change header state when menu opens/closes
    if (this.mainDetailsToggle.open) {
      // Menu opened: set to scrolled state (border-bottom)
      this.header.classList.remove('header-wrapper--landing', 'header-wrapper--scrolled');
      this.header.classList.add('header-wrapper--border-bottom', 'header--initialized');
      this.header.classList.add('header--menu-open');
    } else {
      // Menu closed: check if any other menu is open
      const anyMenuOpen = document.querySelector('header-menu details[open]');
      if (!anyMenuOpen) {
        this.header.classList.remove('header--menu-open');
        // Restore header state based on scroll position
        this.restoreHeaderState();
      }
    }
  }

  restoreHeaderState() {
    const stickyHeader = document.querySelector('sticky-header');
    if (stickyHeader && stickyHeader.restoreHeaderState) {
      stickyHeader.restoreHeaderState();
    } else {
      // Fallback: manually restore state if stickyHeader not available
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const isLandingPage = window.location.pathname === '/' || window.location.pathname === '/index';
      
      if (isLandingPage) {
        if (scrollTop > 0) {
          const heroSection = document.querySelector('.hero-section') || document.querySelector('.section-hero') || document.querySelector('.banner');
          const heroBottom = heroSection ? heroSection.offsetTop + heroSection.offsetHeight : 600;
          const transitionOffset = 7 * 16; // 7rem in pixels
          const transitionPoint = heroBottom - transitionOffset;
          
          if (scrollTop < transitionPoint) {
            // State 3: Scrolled but still within hero - white border
            this.header.classList.remove('header-wrapper--landing', 'header-wrapper--border-bottom');
            this.header.classList.add('header-wrapper--scrolled');
          } else {
            // State 1: Scrolled past transition point - default state
            this.header.classList.remove('header-wrapper--landing', 'header-wrapper--scrolled');
            this.header.classList.add('header-wrapper--border-bottom');
          }
        } else {
          // State 2: At top - transparent
          this.header.classList.remove('header-wrapper--scrolled', 'header-wrapper--border-bottom');
          this.header.classList.add('header-wrapper--landing');
        }
      } else {
        // Other pages: Always use default state (State 1)
        this.header.classList.remove('header-wrapper--landing', 'header-wrapper--scrolled');
        this.header.classList.add('header-wrapper--border-bottom');
      }
    }
  }
}

customElements.define('header-menu', HeaderMenu);
